import React from "react";

import PageHeading from "2g-page-heading";
import Buttons from "2g-buttons";

import ProvozniInformaceSearch, {
  useProvozniInformaceSearch
} from "b2b/components/provozni-informace-search";

const initialValues = { datumOd: "01.01.2022", datumDo: "11.11.2023" };
const onSubmit = ({ values }) => {
  // eslint-disable-next-line no-console
  console.log(values);
};
export function ProvozniInformaceSearchExample() {
  const search = useProvozniInformaceSearch({
    initialValues,
    onSubmit,
    moduleKey: "provozniInformaceSearch"
  });
  return (
    <div className="example-provozniInformaceSearch">
      <PageHeading>ProvozniInformaceSearch</PageHeading>
      <div data-testid="ProvozniInformaceSearch">
        <Buttons.Primary onClick={search.slide.onOpen}>Show</Buttons.Primary>
        <ProvozniInformaceSearch {...search} />
      </div>
    </div>
  );
}

ProvozniInformaceSearchExample.propTypes = {};

export default React.memo(ProvozniInformaceSearchExample);
